import React from 'react';
import { Modal } from 'antd';
import { css } from '@emotion/css';
import { useGlobalAppStore } from '@sharpana/shared/stores/globalAppStore';

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 1rem;
    text-align: center;

    @media (min-width: 768px) {
      padding: 2rem;
    }
  `,
  title: css`
    color: #fff;
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
    font-weight: 600;
  `,
  message: css`
    font-size: 1.125rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
    color: #e0e0e0;
    max-width: 90%;

    @media (min-width: 768px) {
      font-size: 1.25rem;
      max-width: 100%;
    }
  `,
  primaryButton: css`
    background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
    border: none;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 0.75rem 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 4px 12px rgba(37, 117, 252, 0.3);

    &:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(37, 117, 252, 0.4); }
    &:active { transform: translateY(0); box-shadow: 0 2px 8px rgba(37, 117, 252, 0.3); }
  `,
  secondaryButton: css`
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: #e0e0e0;
    font-weight: 500;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    margin-top: 1rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover { background: rgba(255, 255, 255, 0.05); border-color: rgba(255, 255, 255, 0.3); }
  `,
};

const InsufficientTokensModal: React.FC = () => {
  const {
    showInsufficientTokensModal,
    insufficientTokensHasActiveSubscription,
    setShowInsufficientTokensModal,
    setInsufficientTokensHasActiveSubscription,
  } = useGlobalAppStore();

  const handleClose = () => {
    setShowInsufficientTokensModal(false);
    setInsufficientTokensHasActiveSubscription(false);
  };
  const handlePurchase = () => {
    setShowInsufficientTokensModal(false);
    setInsufficientTokensHasActiveSubscription(false);
    // Navigate to paywall
    window.location.href = '/purchase';
  };

  return (
    <Modal
      title={null}
      open={showInsufficientTokensModal}
      onCancel={handleClose}
      footer={null}
      centered
      maskClosable={true}
      closable={true}
      className={css`
        .ant-modal-content {
          background-color: #1f1f1f;
          border-radius: 12px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
        }
        .ant-modal-body { padding: 0; }
        .ant-modal-close {
          color: #999;
          &:hover { color: #fff; }
        }
      `}
      width={380}
    >
      <div className={styles.content}>
        <h3 className={styles.title}>
          {insufficientTokensHasActiveSubscription ? 'Usage limits exceeded' : 'Out of credits'}
        </h3>
        {insufficientTokensHasActiveSubscription ? (
          <>
            <p className={styles.message}>
              Usage limits exceeded. If you think this is a mistake please send us a quick email at support@mrble.ai and we will look into it ASAP.
            </p>
            <button onClick={handleClose} className={styles.primaryButton}>
              Close
            </button>
          </>
        ) : (
          <>
            <p className={styles.message}>
              You don't have enough credits to complete this action. Purchase a credits pack or subscribe to continue.
            </p>
            <button onClick={handlePurchase} className={styles.primaryButton}>
              Purchase credits
            </button>
            <button onClick={handleClose} className={styles.secondaryButton}>
              Not now
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};

export default InsufficientTokensModal;
